import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from "@/components/ui/dialog";
import { Swords } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function DuelStartedDialog({ open, onOpenChange, defenderName, playgroundName }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="bg-[#1B1E28] border-[#6E2BFF] border-2">
                <DialogHeader>
                    <div className="flex items-center justify-center mb-4">
                        <Swords className="w-8 h-8 text-[#6E2BFF] mr-2" />
                        <DialogTitle className="text-white text-xl font-black uppercase">Duel lancé !</DialogTitle>
                    </div>
                </DialogHeader>
                <div className="space-y-4 text-center">
                    <div className="bg-[#13151D] rounded-lg p-6 border border-[#6E2BFF]/30">
                        <p className="text-[#B3B6C2] text-sm uppercase tracking-widest font-bold mb-3">🎯 Duel initié</p>
                        <p className="text-white text-lg font-bold mb-2">{defenderName}</p>
                        <p className="text-[#B3B6C2] text-sm">a <span className="text-[#6E2BFF] font-bold">10 minutes</span> pour accepter</p>
                    </div>
                    <p className="text-[#B3B6C2] text-xs">Terrain : <span className="text-white font-bold">{playgroundName}</span></p>
                    <Button
                        onClick={() => onOpenChange(false)}
                        className="w-full bg-[#6E2BFF] hover:bg-[#8B5CFF] text-white font-bold"
                    >
                        Compris !
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}